/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsSignInRequest
 */
export interface RevisdomAPIViewModelsSignInRequest {
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsSignInRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsSignInRequest
     */
    password?: string | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsSignInRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsSignInRequest(value: object): value is RevisdomAPIViewModelsSignInRequest {
    return true;
}

export function RevisdomAPIViewModelsSignInRequestFromJSON(json: any): RevisdomAPIViewModelsSignInRequest {
    return RevisdomAPIViewModelsSignInRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsSignInRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsSignInRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'password': json['password'] == null ? undefined : json['password'],
    };
}

export function RevisdomAPIViewModelsSignInRequestToJSON(json: any): RevisdomAPIViewModelsSignInRequest {
    return RevisdomAPIViewModelsSignInRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsSignInRequestToJSONTyped(value?: RevisdomAPIViewModelsSignInRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'password': value['password'],
    };
}

